import { isIchOrganization } from "../constants/ichOrganizations";
export const COMMENT_CAPABILITIES_REQUEST = "priceListCommentCapabilitiesRequest";
// Only add a route after its exact deployed template/helpers/assets and all
// consumers have passed comment-line acceptance. Empty deliberately fails closed.
export const VERIFIED_INVOICE_COMMENT_REPORT_ROUTES = Object.freeze([]);
export const configuredInvoiceCommentReportRoutes = orgId => orgId === "332a9d47-6e36-11e8-a392-061714f61e3e"
  ? ["cc-invoices-pdf", "cc-estimates-pdf", "cc-label", "cloud-retail-estimate-inline-pdf"]
  : isIchOrganization(orgId) ? ["ich-selections-2", "ich-selections-portfolio-2", "player-ich-options-inline"] : [];
export const buildInvoiceCommentCapabilitiesResponse = ({ request, sessionId, orgId,
  creationEnabled = process.env.REACT_APP_INVOICE_COMMENTS_ENABLED === "true",
  verifiedReportRoutes = VERIFIED_INVOICE_COMMENT_REPORT_ROUTES } = {}) => {
  if (!sessionId || request?.type !== COMMENT_CAPABILITIES_REQUEST || request.pricingSessionId !== sessionId
    || typeof request.requestId !== "string" || !request.requestId.trim() || request.requestId.length > 200) return null;
  const requiredReportRoutes = configuredInvoiceCommentReportRoutes(orgId);
  const supportedReportRoutes = requiredReportRoutes.filter(route => verifiedReportRoutes.includes(route));
  return { type: "priceListCommentCapabilities", pricingSessionId: sessionId, requestId: request.requestId,
    payload: { protocolVersion: 1, consumerVersion: 1,
      creationEnabled: creationEnabled === true && requiredReportRoutes.length > 0 && supportedReportRoutes.length === requiredReportRoutes.length,
      requiredReportRoutes, supportedReportRoutes } };
};
